import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { PROGRAM_TYPE_FOR_BANNER } from '@ucheba/utils/constants/core'

import { institutionItemSelectors } from '@ucheba/store/institutions/item'
import { TUseBannerProgramTypes } from './types'

export const useBannerProgramTypes: TUseBannerProgramTypes = () => {
  const { paidPackage = null, type } =
    useSelector(institutionItemSelectors.currentInstitution) || {}

  const extraParams = useMemo(
    () =>
      PROGRAM_TYPE_FOR_BANNER[type?.value]
        ? {
            'programTypes[]': PROGRAM_TYPE_FOR_BANNER[type?.value],
          }
        : undefined,
    [] // не ставить type
  )

  return { extraParams, paidPackage }
}
